"use strict";

var questions = [{
  prompt: "A copy of your responses will be sent to your coach. You’ll also be able to see a copy yourself here in the Uprise app",
  type: "multi",
  options: [],
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, {
  prompt: "",
  extraText: "Please write a very short description of the problem that’s making it harder to return to work",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Write down some solutions as you can think of for your problem",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Rank your solutions from best to worst to find your top solutions",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "If you get stuck when ranking, write down at least one Pro and one Con for each solution then rank your solutions",
  placeholder: "",
  type: "multirow",
  aggregated: true
}];
var complete = "Thanks for completing the exercise. <br /><br />A copy of what you’ve written will be available to view shortly and we’ll send your responses to your coach as well.";

var analysis = function analysis(answers) {
  return {
    answer1: answers[1],
    answer2: answers[2],
    answer3: answers[3],
    answer4: answers[4]
  };
};

module.exports = {
  questions: questions,
  complete: complete,
  analysis: analysis
};